import { render, staticRenderFns } from "./ColorFieldtype.vue?vue&type=template&id=c09d2848&"
import script from "./ColorFieldtype.vue?vue&type=script&lang=js&"
export * from "./ColorFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports